<template>
    <div class="row d-none">
        <div class="col-12">
            <button @click="toggle" class="btn sidebar-toggle d-lg-none">
                <i class="fas fa-bars"></i>
            </button>
        </div>
    </div>

    <!-- <div class="d-flex flex-column flex-shrink-0 p-3 bg-body-tertiary sidebar"> -->
    <div :class="['p-3 bg-body-tertiary sidebar', { 'sidebar-mini': collapsed }]">
    <!-- :style="[ {'position': collapsed ? 'abosolute' : 'relative'}, {'margin-left': collapsed ? '200px' : '0px'} ]" -->
        <!-- <a href="/" class="d-flex justify-content-center align-items-center text-decoration-none">
        </a> -->
        <div class="text-center">
            <img src="/assets/images/logo_white.png" class="sidebar-logo">
        </div>
        <a @click="toggle" class="btn sidebar-close position-absolute end-0 top-0 fs-4 fw-bold rounded-circle px-2 py-0 border1 text-light">
            <i class="fas fa-times"></i>
        </a>

        <div class="border-bottom border-secondary mt-3"></div>

        <div class="sidebar-content mt-31 py-2">
            <ul v-if="categories.length > 0" class="btn-toggle-nav list-unstyled fw-normal pb-1 small1">
                <SidebarItem :data="categories" @navigate="navigate" :selectedCategory="selectedCategory" />
            </ul>
        </div>

        <div class="text-light pt-2 pb-11 border-top border-secondary text-center fs-8" v-html="G.footerPowered"></div>

        <!-- <hr>
        <div class="dropdown">
            <a href="#"
                class="d-flex align-items-center link-body-emphasis text-decoration-none dropdown-toggle"
                data-bs-toggle="dropdown" aria-expanded="false"> <img src="https://github.com/mdo.png" alt="" width="32"
                    height="32" class="rounded-circle me-2"> <strong>mdo</strong> </a>
            <ul class="dropdown-menu text-small shadow">
                <li><a class="dropdown-item" href="#">New project...</a></li>
                <li><a class="dropdown-item" href="#">Settings</a></li>
                <li><a class="dropdown-item" data-bs-theme-value="dark" aria-pressed="false">Dark</a></li>
                <li><a class="dropdown-item" href="#">Profile</a></li>
                <li>
                    <hr class="dropdown-divider">
                </li>
                <li><a class="dropdown-item" href="#">Sign out</a></li>
            </ul>
        </div> -->

    </div>
</template>


<script>
// import { ref } from 'vue';

import SidebarItem from '@/pages/components/SidebarItem';

import { G } from '@/_common';

export default {
    name: 'SidebarC',
    components: {
        SidebarItem,
    },
    props: ['collapsed', 'mobileView', 'mini', 'categories', 'selectedCategory'],
    emits: ['toggle', 'navigate'],
    setup(props, { emit }) {
        const navigate = (categoryId) => {
            emit('navigate', categoryId);
        };
        const toggle = () => {
            emit('toggle');
        };

        return {
            G,
            navigate,
            toggle,
        };
    },
}
</script>


<style lang="scss">
.scrollarea {
    overflow-y: auto;
}
.sidebar {
    display: block;
    -webkit-transition: 0.1s ease-out;
    -moz-transition: 0.1s ease-out;
    -o-transition: 0.1s ease-out;
    transition: all 0.1s ease-out;
    // width: var(--sidebar-width);
    left: 0;
    // background-color: var(--bs-tertiary-bg);
    background: var(--background-sidebar-gradient);
    border-radius: 0 20px 20px 0;
}

.sidebar-content {
    overflow-y: auto;
    height: calc(100vh - 123px);
    max-height: calc(100vh - 123px);
}

.sidebar-logo {
    height: 50px;
}

.sidebar.sidebar-mini{
    // width: var(--sidebar-width);
    z-index: 1111;
    position: absolute;
    display: block;
}

.sidebar-close{
    display: none;
}
.footer-info-link{
    color: var(--bs-info) !important;
}

// .sidebar-content ul li:hover{
//     background-color: var(--bs-tertiary-bg);
//     color: #000000 !important;
//     border-radius: 5px;
// }

@media (min-width: 801px) {
    .sidebar.sidebar-mini{
        width: var(--sidebar-width);
        position: relative;
        display: block;
    }
}

@media (max-width: 800px) {
    .sidebar {
        display: none !important;
    }
    .sidebar.sidebar-mini {
        display: block !important;
    }

    .sidebar-toggle {
        display: block;
    }

    .sidebar-close{
        display: block;
    }
}
</style>
